import type { Locale } from 'date-fns';
import { useTranslation } from 'react-i18next';
import i18n from './index';
import { LANGUAGES, languageFromTag } from './languages';

export function getIntlLocale(): string {
  return LANGUAGES[languageFromTag(i18n.language)].tag;
}

export function getDateLocale(): Locale {
  return LANGUAGES[languageFromTag(i18n.language)].dateLocale;
}

export function useLocaleFormat() {
  const { i18n: instance } = useTranslation();
  const { tag, dateLocale } = LANGUAGES[languageFromTag(instance.language)];
  return { intlLocale: tag, dateLocale };
}
